import { useContext } from 'react';

import { GlobalPricingContext } from 'productTemplate/providers/GlobalPricingProvider';

export const useGlobalPricing = () => useContext(GlobalPricingContext);
